<template>
	<div>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Ledgers</v-toolbar-title>

		    <v-spacer></v-spacer>

			<v-btn @click="fn_import" icon><v-icon>publish</v-icon></v-btn>

			<!-- <v-menu>
				<v-btn small slot="activator" icon>
					<v-icon>more_vert</v-icon>
				</v-btn>
				<v-list dense nopadding>
					<v-list-tile @click="fn_exportItems">
						<v-icon font20 class="mr-3">file_download</v-icon>
						<v-list-tile-title>Export Items</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-menu> -->

		    <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>

		    <div full-width slot="extension" class="search-filter" :class="{'bottom-shadow':scrollPositionTop!=0}">
		    	<v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" @input="fn_debounceSearch"></v-text-field>

		    	<div v-ripple class="filter-btn" @click="fn_openDialogFilterItems">
		    		<v-icon>filter_list</v-icon>
		    		<span style="font-size: 48px;position: absolute;bottom: -6px;right: 6px;color: #4b77be;" v-if="selectionItems.selectedFilterItemValue != null || selectionItems.selectedSortValue">&bull;</span>
		    	</div>
		    </div>
		</v-toolbar>

		<div class="hasToolbar hasExtension grey-back" v-scroll="onScroll">


			<v-list grey-back nopadding>

				<v-subheader style="position: sticky;top: 104px;z-index: 1;" white-background subheader-dense>
					Count: {{$root.numberToLocale(listItemObject.totalCount, 1)}}
					<v-spacer></v-spacer>

					<div class="font11 mr-2" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openGroupTypes" v-ripple>
						<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectionItems.groupTypeName ? selectionItems.groupTypeName : 'All'}}</div>
						<v-icon>arrow_drop_down</v-icon>
					</div>

					<div class="font11" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openAccountGroups" v-ripple>
						<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectionItems.accountGroupName ? selectionItems.accountGroupName : 'Group'}}</div>
						<v-icon>arrow_drop_down</v-icon>
					</div>
				</v-subheader>

				<v-subheader v-if="showStrip" @click="fn_import" class="video-link-tile import_strip" primary-color subheader-semi-dense><v-icon color="primary" font20 class="mr-2">publish</v-icon> Import Parties <v-spacer></v-spacer> <v-icon color="primary" font20 @click="fn_removeImportStrip">close</v-icon></v-subheader>

				<v-divider v-else></v-divider>

				<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}" :id="'item_'+item.partyId">

					<v-layout row wrap pt-2 pb-2 pr-3 pl-3 v-ripple @click="fn_itemClick(item.partyId, null, index)">
						<v-flex font16 xs12 sm12 md12>{{item.partyName}}</v-flex>
						<v-flex xs4 sm4 md4 pt-2 light-opacity-color>
							{{item.groupTypeId == 101 ? 'Customer' : item.groupTypeId == 102 ? 'Supplier' : item.groupTypeId == 103 ? 'Other' : ''}}
						</v-flex>
						<v-flex xs8 sm8 md8 right-align pt-2 font16 v-if="item.partyId != '2e87f316-d0bc-4880-83b6-f050e9ffa5da'">
							<!-- <div v-if="item.groupTypeId != 103 || (item.groupTypeId == 103 && item.amount)"> -->
							<template v-if="item.groupTypeId != 103">
								<div>
									<v-icon font20 class="greencolor circle_arrow_icon" v-if="item.balance > 0">arrow_downward</v-icon>
									<v-icon font20 class="redcolor circle_arrow_icon" v-if="item.balance < 0">arrow_upward</v-icon>
									&#8377; {{$root.numberToLocale(roundUpto2Decimals(item.amount))}}
								</div>
								<div class="font12">
                                    <span class="greencolor" v-if="item.balance > 0">To Recieve</span>
                                    <span class="redcolor" v-if="item.balance < 0">To Pay</span>
                                </div>
							</template>
							<template v-else>
                                <div v-if="item.amount">
									<v-icon class="greencolor circle_arrow_icon" v-if="item.balance > 0">arrow_downward</v-icon>
                                    <v-icon class="redcolor circle_arrow_icon" v-if="item.balance < 0">arrow_upward</v-icon>
                                    &#8377; {{$root.numberToLocale(roundUpto2Decimals(item.amount))}}
                                    <div class="font12">
                                        <span class="greencolor" v-if="item.balance > 0">Debit</span>
                                        <span class="redcolor" v-if="item.balance < 0">Credit</span>
                                    </div>
                                </div>
                            </template>
						</v-flex>
					</v-layout>


					<!-- <template> -->
						<v-divider></v-divider>
						<div right-align style="padding:2px 6px">
							<template v-if="item.groupTypeId==101 || item.groupTypeId==102">
								<v-btn nomargin icon flat @click="fn_openDialogTransactionOptions(item)">
									<v-icon font20>add</v-icon>
								</v-btn>
								<v-btn nomargin icon flat @click="fn_newSalePurchase(item)">
									<img src="../../../../assets/icon_invoice.svg" style="opacity:0.54" alt="icon_invoice">
								</v-btn>
								<v-btn nomargin icon flat @click="fn_paymentReminder(item)" v-if="item.balance>0">
									<v-icon font20>notifications_none</v-icon>
								</v-btn>
							</template>

							<v-btn nomargin icon flat @click="fn_itemClick(item.partyId, 1, index)">
								<img style="width:20px;opacity:0.6" src="../../../../assets/icon_pdf_light.svg"/>
							</v-btn>

							<v-menu dense left>
								<v-btn small slot="activator" icon>
									<v-icon>more_vert</v-icon>
								</v-btn>

								<v-list nopadding>
									<v-list-tile @click="fn_copy(item.partyId)">
										<v-list-tile-title>Copy</v-list-tile-title>
									</v-list-tile>
								</v-list>
							</v-menu>
					    </div>	
					<!-- </template> -->
					
				</div>

			</v-list>

			<transition name="fade" mode="out-in">

				<v-card noshadow class="create-placeholder-card" v-if="showPlaceHolder && !listItemObject.totalCount">
					<v-card-text @click="fn_new">

						<div center-align>
			            	<div v-ripple class="placeholder-icon">
			            		<i aria-hidden="true" class="v-icon material-icons add-icon">add</i>
			            		<v-icon style="font-size:42px">person_outline</v-icon>
			            	</div><br>

			            	<p class="title light-opacity-color">Create New Ledger</p>
			            </div>
					</v-card-text>
				</v-card>
				
				<!-- <v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 162px);display: flex;align-items: center;">
					<v-card-text>

						<div center-align>
			            	<div @click="fn_new" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
			            		<i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
			            		<v-icon style="font-size:42px">person_outline</v-icon>
			            	</div><br>

			            	<p class="title light-opacity-color" style="line-height:28px !important">Create New Ledger</p>
			            </div>

					</v-card-text>
				</v-card> -->
			</transition>

            <payment-reminder-card></payment-reminder-card>

		</div>

		<dialog-filter-items ref="ref_dialogFilterItems" type="Ledgers" :filterData="filterData" :setFilter="fn_setFilter" :selectedFilterItemValue="selectionItems.selectedFilterItemValue" :selectedSortValue="selectionItems.selectedSortValue"></dialog-filter-items>
        <dialog-transaction-options ref="ref_dialogTransactionOptions" :groupTypeId="selectedItemObj.groupTypeId" :accountId="selectedItemObj.partyId" :accountName="selectedItemObj.partyName" :closeDialog="fn_closeDialog" v-if="selectedItemObj"></dialog-transaction-options>
		<dialog-selection-list ref="ref_dialogSelectionList" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-selection-list>

		<!-- <canvas id="canvas-due-tab" width="400" height="200" class="payment-reminder-canvas" style="max-width:100%"></canvas> -->
	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../../../config.js').configs.bottomSheetMenu;
import {masterMixin} from '../../master_mixin.js'

const transactionForms = require('../../../../config.js').configs.transactionForms;

const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
const listIdObject = require('../../../../config.js').configs.mastersPredefinedLists;

import dialogTransactionOptions from '../../../dialogs/dialog_transaction_options'

const accountGroupIds = require('../../../../config.js').configs.accountGroupIds;

import dialogFilterItems from '../../../activity/dialogs/dialog_filter';

import paymentReminderCard from '../../../common/payment_reminder_card'

import dialogSelectionList from '../../../dialogs/dialog_selection_list'

	export default{
		mixins: [masterMixin],
		data(){
			return{
				formId:null,
				dialogStorageId:null,

				selectionItems:{
					accountGroupId:null,
					accountGroupName:null,
					groupTypeId:100,
					groupTypeName:"All",
					selectedFilterItemValue:null,
					selectedSortValue:0

				},

				backButtonPress:false,

                selectedItemObj:null,

				filterData:{
					filterItems:[
						{"filterItemId":1, "name":"All", "value":null},
						{"filterItemId":2, "name":"To Receive", "value":1},
						{"filterItemId":3, "name":"To Pay", "value":0}
					],
					sortItems:[
						{"sortId":1, "name":"Party Name", "value":0},
						{"sortId":2, "name":"Amount - High to Low", "value":1},
						{"sortId":3, "name":"Amount - Low to High", "value":2}
					],
				},
				
				showStrip:false

			}
		},
		components: {
		    'dialog-filter-items': dialogFilterItems,
            'dialog-transaction-options': dialogTransactionOptions,
			'payment-reminder-card':paymentReminderCard,
			'dialog-selection-list':dialogSelectionList
		},
		methods:{

			fn_import: function(){
				if(this.$root.appVersion >= 117){
					this.$router.push({path:"/masters/accounts/ledgers/items/import"});
				}
				else{
					this.$eventHub.$emit('AppUpdateDialog');
				}
			},

			fn_removeImportStrip: function(event){
				event.stopPropagation();
				this.showStrip = false;
				localStorage.setItem('remove_import_party_strip', 1);
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			},

			fn_copy: function(partyId){
				this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), itemId:partyId, copy:true}});
			},

			fn_new: function(){
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = this.listItemObject.items.length;
          		localStorage.setItem("ledgers_items_state", JSON.stringify(obj));

				let groupTypeId = this.selectionItems.groupTypeId && this.selectionItems.groupTypeId != 100 ? this.selectionItems.groupTypeId : 101;
				this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), routeToDisplay:true, groupTypeId:groupTypeId}});
			},

            fn_newSalePurchase: function(item){
				if(item.groupTypeId == 101){
					this.$router.push({path:"/transactions/sales/saleinvoice/items/new", query:{tagId:this.guidWeb(), id:item.partyId, name:item.partyName, dt:1}});
				}
				else{
					this.$router.push({path:"/transactions/purchase/purchaseinvoice/items/new", query:{tagId:this.guidWeb(), id:item.partyId, name:item.partyName, dt:1}});
				}
			},

            fn_openDialogTransactionOptions: function(item){
				this.selectedItemObj = item;
				setTimeout(() => {
                    this.fn_openDialogWeb('web', 'TransactionOptions', 'ref_dialogTransactionOptions');
                }, 300);
			},

			fn_paymentReminder: function(item){
				let self = this;
                document.getElementById("reminder_amount").innerText = "₹ " + this.$root.numberToLocale(this.roundUpto2Decimals(item.amount));
				this.$root.fn_checkStoragePermission(function(){
                    let obj = {};
					obj.amount = item.amount;
					obj.primaryMobileNumber = item.primaryMobileNumber;
					obj.email = item.email;
					// self.$root.fn_sendPaymentReminder(obj, "canvas-due-tab");
                    self.$root.fn_generateImage(obj);
                });
			},

			fn_setFilter: function(filterItemId, sortId){
				this.selectionItems.selectedFilterItemValue = filterItemId;
				this.selectionItems.selectedSortValue = sortId;
				this.fn_closeDialog();
				this.fn_searchItem();
			},

			fn_menuItemClick: function(tagId, menuId, menuAction, itemId){
				if(menuAction=='draft'){
					this.$router.push({path:'/drafts', query:{tabIndex:0}});
				}
				else if(menuAction=='delete'){
					let self = this;
					this.fn_deleteMasterItem('accounts', itemId, function(response){
						if(response){
	                        self.showToast('Item deleted');
	                    }
	                    else{
	                        self.showToast("Item cannot be deleted as already in use");
	                    }
					})
				}
				else if(menuAction == 'clearallfilters'){
					this.fn_clearAll();
				}
			},

			fn_openGroupTypes: function(){
				let obj = {};
				obj.functionName = 'ledgerGroupType';
				obj.toolbarTitle = 'Select Ledger Type';
				obj.itemId = this.selectionItems.groupTypeId;
				obj.itemName = this.selectionItems.groupTypeName;
				this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_groupType', obj);
			},
			// fn_openLedgerTypes: function(){
			// 	let viewDialogObject = { ToolbarTitle:"Ledger Type", ref:"ref_groupType", hasLocalItems:1 };
			// 	if(this.selectionItems.groupTypeId && this.selectionItems.groupTypeName){
			// 		viewDialogObject.selectedItem = {"itemId":this.selectionItems.groupTypeId, "itemName":this.selectionItems.groupTypeName};
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Ledger Type', 'ref_dialogSelectionList');
			// },

			fn_getlocalItems: function(){
				let ledgerTypes = [{"itemId":100, "itemName":"All"},{"itemId":101, "itemName":"Customer"},{"itemId":102, "itemName":"Supplier"}]
				return ledgerTypes;
			},

			fn_openAccountGroups: function(){
				let obj = {};
				obj.functionName = 'accountgroups';
				obj.toolbarTitle = 'Select Group';
				obj.itemId = this.selectionItems.accountGroupId;
				obj.itemName = this.selectionItems.accountGroupName;
				this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_accountGroup', obj);
			},

			// fn_openAccountGroupsDialog: function(){

			// 	let viewDialogObject = { ToolbarTitle:"Account Group", fnName:"AccountGroupDialog", ref:"ref_accountGroup", dbSearch:true };

			// 	if(this.selectionItems.groupTypeId==101 || this.selectionItems.groupTypeId==102){
			// 		let accountGroupId = this.selectionItems.groupTypeId == 101 ? accountGroupIds.debtors.id : accountGroupIds.creditors.id;
			// 		viewDialogObject.accountGroupIds = [accountGroupId];
			// 	}

			// 	if(this.selectionItems.accountGroupId && this.selectionItems.accountGroupName){
			// 		viewDialogObject.selectedItem = {"itemId":this.selectionItems.accountGroupId, "itemName":this.selectionItems.accountGroupName};
			// 		viewDialogObject.clearBtn = true;
			// 	}

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Account Group', 'ref_dialogSelectionList');
			// },

			// fn_clearAll: function(){
			// 	this.selectionItems.groupTypeId = null;
			// 	this.selectionItems.accountGroupId = null;
			// 	localStorage.removeItem('item_filter');
			// 	this.fn_filterData();
			// },

			fn_itemClick: function (itemId, shareStatement, index) {
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("ledgers_items_state",JSON.stringify(obj));

				if(shareStatement){
					// this.$router.push({path:'/masters/accounts/ledgers/items/'+itemId, query:{statementType:1}});
					this.$router.push({path:"/masters/accounts/ledgers/items/"+itemId+"/statement"});
				}
				else{
					this.$router.push('/masters/accounts/ledgers/items/'+itemId);
				}
				// this.$router.push('/masters/accounts/ledgers/items/'+itemId);
			},

			fn_getBottomMenu: function (tagId, elementId, isSystem) {
				let bottomMenu;

				if(elementId == bottomSheetMenu.toolBar.Id){
					bottomMenu = {"BottomMenu": [menuItem.help]};
				}
				else if(elementId == bottomSheetMenu.masterListItems.Id){
					bottomMenu = {"BottomMenu": [menuItem.copy]};
					!Number(isSystem) ? bottomMenu = {"BottomMenu": [menuItem.edit, menuItem.copy]} : '';
				}
				else if(elementId == bottomSheetMenu.moreFilters.Id){
					// menuItem.filterGroupType.selectedItem = this.selectionItems.groupTypeId ? this.selectionItems.groupTypeName : null;
					menuItem.filterAccountGroup.selectedItem = this.selectionItems.accountGroupId ? this.selectionItems.accountGroupName : null;
					// bottomMenu = {"BottomMenu": [menuItem.filterGroupType, menuItem.filterAccountGroup]};
					bottomMenu = {"BottomMenu": [menuItem.filterAccountGroup]};
					// if(this.selectionItems.groupTypeId || this.selectionItems.accountGroupId){
					if(this.selectionItems.accountGroupId){
						bottomMenu.BottomMenu.push(menuItem.clearAll);
					}
				}

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_openDialogAndroid: function (platform, name, ref, obj) {

				let tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = obj.toolbarTitle;
				viewDialogObject.isBottomMenu = false;

				if(ref == 'ref_groupType'){
					viewDialogObject.groupTypes = [
						{"id":100, "name":"All"},
						{"id":101, "name":"Customer"},
						{"id":102, "name":"Supplier"},
						{"id":103, "name":"Other"}
					]

					this.$root.TransactionSettings.branchDivision ? viewDialogObject.groupTypes.push({"id":104, "name":"Branch/Division"}) : '';
				}

				if(ref=="ref_accountGroup" && (this.selectionItems.groupTypeId==101 || this.selectionItems.groupTypeId==102)){
					let accountGroupId = this.selectionItems.groupTypeId == 101 ? accountGroupIds.debtors.id : accountGroupIds.creditors.id;
					viewDialogObject.accountGroupIds = [accountGroupId];
				}

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(obj.itemId && obj.itemName){
					paramObject.defaultValue = {"id":obj.itemId, "name":obj.itemName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, obj.functionName, tagId, paramObject, ref);
			},

			fn_openDialogFilterItems: function(){
				this.fn_openDialogWeb('web', 'FilterItems', 'ref_dialogFilterItems');
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function () {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				if(ref == 'ref_groupType'){
					this.selectionItems.groupTypeId = !isRemoved ? selectedValueId : null;
					this.selectionItems.groupTypeName = !isRemoved ? selectedValueName : null;
				}
				else if(ref == 'ref_accountGroup'){
					this.selectionItems.accountGroupId = !isRemoved ? selectedValueId : null;
					this.selectionItems.accountGroupName = !isRemoved ? selectedValueName : null;
				}

				// if(ref == 'ref_accountGroup'){
				// 	this.selectionItems.accountGroupId = !isRemoved ? selectedValueId : null;
				// 	this.selectionItems.accountGroupName = !isRemoved ? selectedValueName : null;
				// }

				isRemoved ? this.fn_closeDialog() : '';

				this.fn_searchItem();
				// this.fn_filterData(true);
			},

			// fn_filterData: function(cacheData){
			// 	let filterObject = {};
			// 	// this.selectionItems.groupTypeId ? filterObject.groupTypeIds = [this.selectionItems.groupTypeId] : '';
			// 	this.selectedGroupTypeId ? filterObject.groupTypeIds = [this.selectedGroupTypeId] : '';
			// 	this.selectionItems.accountGroupId ? filterObject.accountGroupIds = [this.selectionItems.accountGroupId] : '';

			// 	cacheData ? localStorage.setItem('item_filter', JSON.stringify(this.selectionItems)) : '';
			// 	this.refreshData('account', this.$route.query.tagId, filterObject);
			// },

			// fn_selectedGroupTypeId: function(groupTypeId){
			// 	if(groupTypeId == 101 || groupTypeId == 102){
			// 		let groupType = groupTypeId == 101 ? 'Customer' : 'Supplier';
			// 		this.$router.push({name:'ledgerItemsWeb', query:{tagId:this.guidWeb(), groupType:groupType}, params: { 'isNew': 1 }});
			// 	}
			// 	else{
			// 		this.selectedGroupTypeId = groupTypeId == 'null' ? null : Number(groupTypeId);
			// 		this.fn_filterData(true);
			// 	}
				
			// }

			// fn_setGroupType: function(){
			// 	if(this.$route.query.groupType == 'Customer'){
			// 		this.selectionItems.groupTypeId = 101;
			// 		this.selectionItems.groupTypeName = "Customer";
			// 	}
			// 	else if(this.$route.query.groupType == 'Supplier'){
			// 		this.selectionItems.groupTypeId = 102;
			// 		this.selectionItems.groupTypeName = "Supplier";
			// 	}
			// 	else{
			// 		this.selectionItems.groupTypeId = null;
			// 		this.selectionItems.groupTypeName = null;
			// 	}
			// 	this.fn_filterData(true);
			// }

			fn_loadItems: function() {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue ? this.searchValue.toLowerCase() : '';

				filterObject.groupTypeIds = this.selectionItems.groupTypeId && this.selectionItems.groupTypeId != 100 ? [this.selectionItems.groupTypeId] : [];
				filterObject.accountGroupIds = this.selectionItems.accountGroupId ? [this.selectionItems.accountGroupId] : [];

				filterObject.balanceType = this.selectionItems.selectedFilterItemValue;
				filterObject.sortByAmount = this.selectionItems.selectedSortValue;
				// filterObject.sortByAmount = this.selectedSortValue;

				let pageState = null;
				if(localStorage.getItem("ledgers_items_state")){
					pageState = JSON.parse(localStorage.getItem("ledgers_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				console.log(filterObject.limit);

				localStorage.setItem('item_filter', JSON.stringify(this.selectionItems));

				let self = this;
				this.getItems("LedgerList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;
							// self.listItemObject.totalReceivables = responseJson.totalReceivables ? responseJson.totalReceivables : 0;
							// self.listItemObject.totalPayables = responseJson.totalPayables ? responseJson.totalPayables : 0;

							let itemFound = false;

							for(let i in responseJson.items){

								if(pageState && pageState.itemId){
									if(responseJson.items[i].partyId == pageState.itemId){
										itemFound = true;
									}
								}

								let itemIndex = self.listItemObject.items.findIndex(item => item.partyId==responseJson.items[i].partyId);

								if(itemIndex==-1){
									self.listItemObject.items.push(responseJson.items[i]);	
								}
								// self.listItemObject.items.push(responseJson.items[i]);
							}

							console.log(pageState);
							if(pageState && pageState.itemId){
								setTimeout(function(){
									if(itemFound){
										let scrollOptions = {"duration":0, "offset":-112, "easing":"linear"};
										self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
										localStorage.removeItem("ledgers_items_state");
									}
									else{
										self.$vuetify.goTo(99999, self.scrollOptions);
									}
								},100);
							}

							if(pageState && !pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":300, "offset":0, "easing":"linear"};
									self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
									localStorage.removeItem("ledgers_items_state");
								},100);
							}

							console.log(self.listItemObject.items);

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

							setTimeout(function(){
								self.showPlaceHolder = true;
							},300)
						},
						onError: function (error) {
							console.log(error);
							// self.loadMore = false;
						}
					}
				)
		    },

		    fn_searchItem: function () {
				this.startIndex = 0;
				this.listItemObject.items = [];
				this.fn_loadItems();
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = null;
				this.$route.params && this.$route.query.tagId ? tagId = this.$route.query.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction, itemId) {
							self.fn_menuItemClick(tagId, menuId, menuAction, itemId)
						}
					}
				);
			},

			fn_exportItems: function(){
				var self = this;
				this.showLoading("Please wait...");
				this.getData('GetExportAccounts', null, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							if(data && data.items && data.items.length){
								self.fn_processItems(data.items);	
							}
				        }, 
				        onError: function(error){
				          	console.log(error);
							self.hideLoading();
							self.showToast("Something went wrong. Try again.");
				        }
					}
		        );
			},

			fn_processItems: function(items){
				let sheetArray = [];
				let headerRow = ["Name", "Type", "Group", "Mobile Number", "Email", "Opening", "GST Number", "Place Of Supply", "PAN Number", "Country", "Billing Address",	"Billing City", "Billing State", "Billing Pincode", "Shipping Address",	"Shipping City", "Shipping State", "Shipping Pincode"]
				sheetArray.push(headerRow);
				for(let i=0; i<items.length; i++){
					let row = [];
					row.push(items[i].name);
					row.push(items[i].groupTypeId == 101 ? 'Customer': items[i].groupTypeId == 102 ? 'Supplier' : 'Other');
					row.push(items[i].accountGroupName);
					row.push(items[i].primaryMobileNumber);
					row.push(items[i].email);
					row.push(items[i].openingValue);
					row.push(items[i].gstNumber);
					row.push(items[i].placeOfSupply);
					row.push(items[i].panNumber);
					row.push(items[i].country);
					row.push(items[i].billingAddress);
					row.push(items[i].billingCity);
					row.push(items[i].billingState);
					row.push(items[i].billingPincode);
					row.push(items[i].shippingAddress);
					row.push(items[i].shippingCity);
					row.push(items[i].shippingState);
					row.push(items[i].shippingPincode);
					sheetArray.push(row);
				}

				const XlsxPopulate = require('xlsx-populate');
				XlsxPopulate.fromBlankAsync().then(workbook => {
					workbook.sheet(0).cell("A1").value(sheetArray);
					workbook.sheet(0).name('Ledgers');
					workbook.sheet(0).range("A1:R1").style({"fill": "92D050", "bold": true});
					workbook.outputAsync("base64").then(base64=> {
						let raw = window.atob(base64);
						let rawLength = raw.length;
						let array = new Uint8Array(new ArrayBuffer(rawLength));

						for(let i = 0; i < rawLength; i++) {
							array[i] = raw.charCodeAt(i);
						}

						let fileName = "ledgers_"+this.$root.fn_getCurrentDateTimeString();
        
						let chunkcounter = 0;
						if(typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null){
							console.log('inside');

							//opening file
							let fileId = this.guidWeb();
							AndroidRoutingTest.openFile(fileId, fileName+'.xlsx');

							//writing file
							let chunkSize = array.BYTES_PER_ELEMENT * 1000 * 2; //self.$parent.datachunksize //1 byte
							for (let i = 0; i < array.length; i += chunkSize) {
								let datachunk = array.slice(i, i + chunkSize)
								AndroidRoutingTest.writeFile(fileId, datachunk);
								console.log(++chunkcounter);
							}

							//closing file
							console.log("close");
							this.hideLoading();
							this.fn_closeAndExportExcelFile(fileId);
						}
					});
				})
			},

			fn_closeAndExportExcelFile: function(fileId){
				let self = this;
				this.closeFile(fileId, {
					onSuccess: function(response){
						console.log(response);
						self.snackbar = true;
						self.showToast('File downloaded ' + response);
					}, 
					onError: function(error){
						console.log(error);
						self.showToast('File download failed');
					}
				});
			},
		},
		mounted: function(){

			this.fn_showWebView();

			this.showStrip = localStorage.getItem('remove_import_party_strip') ? false : true;

			window.js_globals.fn_onBackPress = this.fn_goBack;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			// window.js_globals.fn_selectedGroupTypeId = this.fn_selectedGroupTypeId;

			// if(this.$route.query && this.$route.query.groupType == 'Customer'){
			// 	this.selectionItems.groupTypeId = 101;
			// 	viewObject.ToolbarTitle = "Customer";
			// 	viewObject.isFilterView = false;
			// }
			// else if(this.$route.query && this.$route.query.groupType == 'Supplier'){
			// 	this.selectionItems.groupTypeId = 102;
			// 	viewObject.ToolbarTitle = "Supplier";
			// 	viewObject.isFilterView = false;
			// }
			// else{
			// 	viewObject.enableFilterChip = true;
			// 	viewObject.filter.groupTypeIds = null;
			// 	// this.selectionItems.groupTypeId = null;
			// }

			if(localStorage.getItem('item_filter')){
				let data = JSON.parse(localStorage.getItem('item_filter'));
				this.selectionItems.accountGroupId = data.accountGroupId ? data.accountGroupId : null;
				this.selectionItems.accountGroupName = data.accountGroupName ? data.accountGroupName : null;
				this.selectionItems.groupTypeId = data.groupTypeId ? data.groupTypeId : 0;
				this.selectionItems.groupTypeName = data.groupTypeName ? data.groupTypeName : null;

				// this.selectionItems.selectedFilterItemValue = data.selectedFilterItemValue ? data.selectedFilterItemValue : null;
				this.selectionItems.selectedFilterItemValue = data.selectedFilterItemValue;
				this.selectionItems.selectedSortValue = data.selectedSortValue ? data.selectedSortValue : 0;
			}
			// else{
			// 	localStorage.setItem('item_filter', JSON.stringify(this.selectionItems));
			// }

			if(this.$route.params.groupTypeId){
				if(this.$route.params.groupTypeId == 101){
					this.selectionItems.groupTypeId = 101;
					this.selectionItems.groupTypeName = "Customer";	
				}
				else if(this.$route.params.groupTypeId == 102){
					this.selectionItems.groupTypeId = 102;
					this.selectionItems.groupTypeName = "Supplier";	
				}
			}

			// this.selectionItems.groupTypeId ? viewObject.groupTypeIds = [this.selectionItems.groupTypeId] : '';
			// this.selectionItems.accountGroupId ? viewObject.accountGroupIds = [this.selectionItems.accountGroupId] : '';

			// viewObject.filter = {};
			// viewObject.filter.groupTypeIds = [];
			// if(this.selectionItems.groupTypeId){
			// 	viewObject.filter.groupTypeIds.push(this.selectionItems.groupTypeId);
			// }
			// viewObject.filter.groupTypeIds = []
			
			// let tagId = this.$route.query.tagId;
			this.formId = this.$route.query.tagId;
			this.dialogStorageId = 'dialog_'+this.formId;

			this.fn_loadItems();

			

			//setting up group types to filter as per group type
			// if(this.$route.query && this.$route.query.groupType){
			// 	let self = this;
			// 	setTimeout(function(){
			// 		self.fn_setGroupType()
			// 	},300)
			// }
		},
		beforeRouteLeave (to, from, next) {
		  	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
                if(this.backButtonPress){
                    dialogjs.fn_checkAndCloseOpenDialogs(this);
                    this.backButtonPress = false;
                    next(false);
                }
                else{
                    next(true);
                }
			}
			else{
				// this.fn_closeView(this.$route.query.tagId);
				this.backButtonPress ? localStorage.removeItem('item_filter') : '';
				next();
			}
		  	// else if(!this.viewClosed){
		  	// 	this.fn_closeView(this.$route.query.tagId);
		  	// 	this.viewClosed = true;
		  	// 	next();
		  	// }
		  	// else{
		  	// 	next();
		  	// }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/items.vue